<div class="container">
  <div class="row">
    <div class="col-md-4">
      <div class="sidebar left">
        <div class="my-account-nav-container">
          <h4 class="margin-top-0">Forgot Password</h4>
          <label>Enter your email address or user name in the text field, then click the 'Send Email' button.</label>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-6  my-profile" style="padding: 2%;">
          <form #forgotPasswordForm="ngForm" class="login" (ngSubmit)="SaveBtnClick()">
            <div class="row margin-bottom-10">
              <div class="col-md-12">
                <div class="form-group" [class.has-error]="userControl.invalid && userControl.touched"
                  [class.has-success]="userControl.valid">
                  <label for="emailAddress" class="control-label">User Name / Email Address:<i
                      class="fa fa-asterisk"></i></label>
                  <input type="text" maxlength="100" class="input-text" name="emailAddress" [(ngModel)]="Email" id="emailAddress"
                    value="" required data-message="please enter valid user name!" #userControl="ngModel" />
                  <div class="notification error" *ngIf="userControl.invalid && userControl.touched">
                    <p>User Name or email address filed is required</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p class="form-row">
                  <input type="submit" class="submit button margin-top-10" id="submit" value="Send Email"
                    [disabled]="forgotPasswordForm.invalid" />
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <p class="notification error">*** Don't see the password email in your Inbox, be sure to check your Spam
            folder.</p>
          <!-- <p>** If you registered and are having trouble logging in for the first time, check your email for an
            automated email that includes a link to confirm your registration.
          </p>
          <p>You must click the link in this email in order for your registration to work. Resetting your password will
            not be effective until you confirm your registration.
          </p> -->
          <br><br><br><br><br><br><br>
        </div>
      </div>
    </div>
  </div>
</div>
